const secretId = "AKIDb3HH2WkhOvEH4aqqa4IGyQbV8VccS4Rb"; // 客户的secretId
const secretKey = "zkHYaNuBCyZw450h9ZooZ5MM6aqreDWb"; // 客户的secretKey
const appId = "eXDcYRIb"; // 体验机器人的appkey
const ipUrl = "10.40.92.218"; // 部署地址的ip  // 10.40.92.218   //localhost
const port = 9092; // 部署地址的端口号
const serverIpUrl = "xqd.zhihuiqice.com"; // 请求代理地址的ip  //xqd.zhihuiqice.com   //localhost
const serverPort = 10023; // 请求代理地址的端口号
const httpType = "https"; // http还是https

module.exports = {
  secretId,
  secretKey,
  appId,
  ipUrl,
  port,
  serverIpUrl,
  serverPort,
  httpType,
};



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 5